<span *ngIf="!isEditing">{{field.value}}</span>
<input *ngIf="isEditing" type="number" [(ngModel)]="field.value" class="form-control" (change)="fieldUpdated.emit(field)" placeholder="Enter a number">